<template>
	<div class="mb-3 clearfix">
		<p class="lh-1 mb-0" v-if="settings.caption">{{ settings.caption }}</p>
		<template v-if="settings.ready">
			<div class="list-group border-radius-2 no-border"  v-if="settings.value">
				<div class="list-group-item" v-for="(item, ikey) in settings.value" :key="ikey">
					<p class="mb-0"><strong>{{item.datetime}}</strong></p>
					<p style="white-space: pre-wrap;">{{item.text}}</p>
				</div>
			</div>
			<div v-else class="alert alert-info">{{$t('no-results')}}</div>
		</template>
		<div v-else>
			<div class="skeleton midnight h20 mb-3" v-for="n in 5" :key="n"></div>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	},
	props: {
		settings: Object
	},
	data() {
		return {
		};
	},
	mounted() {
	},
	watch: {
	},
	computed: {
	}
};
</script>
